export enum SortKanbanBy {
  StageUpdatedAt = 'stage_updated_at',
  StageDeadline = 'stage_deadline',
  KanbanPriority = 'kanban_priority',
}

export enum SortKanbanDirection {
  ASC = 'ASC',
  DESC = 'DESC',
}

export enum CategoryStrict {
  Strict = '1',
  NotStrict = '0',
}

export enum KanbanTimeOffStatus {
  Upcoming = 'UPCOMING',
  Completed = 'COMPLETED',
}

export enum KanbanTimeOffSubjectCode {
  ELA = 'ELA',
  Math = 'MATH',
}
